/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".link-arrows.js-switch-user-info[_ngcontent-%COMP%]{cursor:pointer}.error-txt[_ngcontent-%COMP%]{display:block}"];
export { styles as styles };
